
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <!-- <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.title" placeholder="输入课程名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item> -->
            <el-form-item >
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="40">
            </el-table-column>
            <el-table-column prop="apid" label="ID" width="60">
            </el-table-column>
            <el-table-column prop="name" label="课程名称" width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="update(scope.row)"><i
                            class="el-icon-edit" />修改</el-button>
                    <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add>
       <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update>

    </div>
</template>
    
<script>
import { getCp,getCpdel,getCpedit } from '../../api/userMG';
import Pagination from '../../components/Pagination';
import Add from './add.vue';
import Update from './update.vue';
export default {
    // 注册组件
    components: {
        Pagination,Add,Update
    },
    data() {
        return {
            dialog: {
                addDialogStatus: false,
                updateDialogStatus:false
            },
            loading: false, //是显示加载
            formInline: {
                title: '',
                page: 1
            },
            updateInfo:{},
            listData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
        }
    },
    created() {
        this.getdata()
        this.generateBreadcrumb()
    },
    watch: {
        $route() {
            this.generateBreadcrumb()
        }
    },
    methods: {
        add(){
           this.dialog.addDialogStatus = true
        },
        search() {
            this.getdata()
        },
        del(row) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getCpdel({ apid: row.apid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '删除成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: '删除失败', type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        update(row){
            getCpedit({ apid: row.apid, echo: 'get' }).then(res => {
                console.log(res);
                if (res.code == 200) {
                this.dialog.updateDialogStatus = true
                this.updateInfo = res.info
                }
            })
        },
        generateBreadcrumb() {
            // 获取当前路由信息
            const matched = this.$route.matched
            console.log(matched, '++++++++++');
            // 初始化面包屑导航数据
            const breadcrumbList = []
            // 遍历路由信息，生成面包屑导航数据
            matched.forEach(item => {
                const { meta, name, path } = item
                if (meta.requireAuth) {
                    breadcrumbList.push({
                        name,
                        path
                    })
                }
            })
            console.log(breadcrumbList, '=========');
            // 保存面包屑导航数据
            this.breadcrumbList = breadcrumbList
        },
        getdata() {
            this.loading = true
            getCp(this.formInline).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.listData = res.info.data
                    this.pageparm.total = res.info.total
                     this.loading = false
  
                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
    
<style scoped>
.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}
</style>
    
     
     


// WEBPACK FOOTER //
// src/views/product/index.vue